export const LANGS = [
  { code: "ru", label: "RU" },
  { code: "en", label: "EN" },
  { code: "pl", label: "PL" },
];

const EVENT_TRANSLATIONS = {
  ru: {
    nav: {
      brand: "Business Conf · Вроцлав",
    },
    hero: {
      date_chip: "31.10",
      date_sub: "10:30 · Вроцлав, Польша",
      title1: "BUSINESS",
      title2: "CONFERENCE",
      desc: "Прокачай нетворкинг, личный бренд и бизнес в кругу единомышленников во Вроцлаве. Один день, который изменит траекторию вашего следующего года.",
      cta_tickets: "Выбрать билет",
      cta_program: "Программа дня",
      stat1k: "", stat1v: "",
      stat2k: "9", stat2v: "Форматов",
      stat3k: "1", stat3v: "День, который вы запомните",
      stage_kicker: "Главная сцена",
      stage_title: "Поток инсайтов",
    },
    program: {
      eyebrow: "Что внутри",
      title: "Программа конференции",
      desc: "Девять элементов программы, выстроенных так, чтобы каждый участник вышел с реальными контактами и инсайтами.",
      items: [
        { title: "Кейноуты топ-спикеров", text: "Глубокие выступления от практиков с реальным опытом и кейсами." },
        { title: "Подарки каждому гостю", text: "Welcome-набор и сюрпризы от партнёров мероприятия." },
        { title: "Авторский нетворкинг", text: "Структурированный формат знакомств — без неловких пауз." },
        { title: "Закрытый чат-сообщество", text: "Доступ к приватному чату участников после конференции." },
        { title: "Welcome drink & finger food", text: "Лёгкий фуршет в приятной атмосфере." },
        { title: "Интерактивные воркшопы", text: "Практические сессии — забираете с собой инструменты, а не теорию." },
        { title: "Премиум фотозона", text: "Идеальные кадры для соцсетей и личного бренда." },
        { title: "Профессиональная съёмка", text: "Фото и видео-репортаж — материалы для вашего контента." },
        { title: "Afterparty", text: "Неформальный нетворкинг и игра «Мафия» с участниками." },
      ],
    },
    speakers: {
      eyebrow: "Сцена",
      title: "Спикеры",
      desc: "Практики из бизнеса, маркетинга, инвестиций и личного бренда.",
      role_label: "Тема",
      list: [
        {
          name: "Marina Fedak",
          role: "Предприниматель в beauty-индустрии 🇵🇱. В beauty-индустрии с 2017 года. Владелица салона с командой из 15 человек.",
          teaser: "Тайм-менеджмент предпринимателя: как успевать вести бизнес, управлять командой и личной жизнью",
        },
        {
          name: "Роксолана IvRoxe",
          role: "Основательница сети медицинских учреждений IvRoxe. 7 локаций в 6 городах Польши, 70+ человек в команде.",
          teaser: "Ошибки продвижения бизнеса и реклама, которая эффективна на польском рынке",
        },
        {
          name: "Anastasiia Kasian",
          role: "Владелица школы делового польского @itpolski и маркетолог с 10-летним опытом в Польше (PORTA, MILKA, Disney, MasterCard).",
          teaser: "Где искать дофинансирование для бизнеса в Польше: суммы, документы и подводные камни",
        },
        {
          name: "Анна Хорошилова",
          role: "Контент-продюсер с 10-летним опытом и блогер с аудиторией 7К+ подписчиков.",
          teaser: "Последний шанс зайти на YouTube? Почему свой канал стоит запускать уже сегодня",
        },
        {
          name: "Виктор Бартак",
          role: "Владелец SEO-агентства №1 в B2B по версии UK Search Awards.",
          teaser: "Привлечение клиентов из Google и ChatGPT",
        },
        {
          name: "Татьяна Алексеева",
          role: "Founder&Owner международной сети RACCOON SCHOOL — образовательного бизнеса в Украине и Польше с 11-летней историей.",
          teaser: "Психология владельца бизнеса: позиционирование, границы с командой, делегирование и заработок в кризис",
        },
      ],
      tba_title: "Спикеры будут объявлены в ближайшее время",
      tba_desc: "Мы формируем сильный состав экспертов и практиков бизнеса. Следите за обновлениями!",
    },
    atmosphere: { eyebrow: "Атмосфера", title: "Наша атмосфера", desc: "" },
    organizers: {
      eyebrow: "Команда",
      title: "Организаторы",
      list: [
        {
          name: "Дина Завадская",
          role: "Маркетолог с опытом более 4 лет, владелица 2-ух онлайн бизнесов",
          photo: "/events/wroclaw-2026/speakers/Dina.jpeg",
        },
        {
          name: "Денис Новиков",
          role: "Консультант по развитию бизнеса и продаж с опытом больше 15 лет, ивент-продюсер, страховой агент",
          photo: "/events/wroclaw-2026/speakers/Denis.jpeg",
        },
      ],
    },
    pricing: {
      eyebrow: "Билеты",
      title: "Выберите формат участия",
      desc: "Пять вариантов — от стандартного билета до выступления на главной сцене.",
      footer: "Оплата картой через защищённое соединение Stripe. После оплаты вы получите место в закрытом чате участников.",
      badges: { popular: "Популярный", premium: "Премиум" },
      tickets: {
        standard: {
          name: "Стандарт",
          sub: "",
          cta: "Купить билет",
          perks: [
            "Полный доступ к конференции и всем выступлениям",
            "Закрытый чат-сообщество участников",
            "Welcome-подарки и сертификат участника",
          ],
        },
        standard_duo: {
          name: "Стандарт 1+1",
          sub: "Для 2 человек",
          cta: "Купить на двоих",
          perks: [
            "Всё, что входит в Стандарт — для двух человек",
            "Два билета по специальной цене (75 PLN / чел.)",
            "Совместный нетворкинг и доступ в закрытый чат",
          ],
        },
        speaker_10: {
          name: "Speaker 10 мин",
          sub: "Выступление со сцены",
          cta: "Выступить 10 мин",
          perks: [
            "Всё, что входит в пакет Стандарт",
            "10 минут выступления о себе/проекте перед аудиторией",
            "Возможность раздать визитки или флаеры участникам",
          ],
        },
        speaker_30: {
          name: "Speaker 30 мин",
          sub: "Главный спикер",
          cta: "Выступить 30 мин",
          perks: [
            "Всё, что входит в пакет Стандарт",
            "30 минут выступления со слайдами на главной сцене",
            "Максимальное позиционирование эксперта и анонс в соцсетях",
          ],
        },
        afterparty: {
          name: "After party",
          sub: "Вечерняя программа",
          cta: "На After party",
          perks: [
            "Неформальный нетворкинг в клубной атмосфере",
            "Игра в «Мафию» с участниками и организаторами",
            "Отличная атмосфера и новые деловые знакомства",
          ],
        },
      },
    },
    partners: { eyebrow: "Партнёры", title: "Поддерживают мероприятие" },
    faq: {
      eyebrow: "FAQ",
      title: "Частые вопросы",
      items: [
        { q: "Где проходит конференция?", a: "Вроцлав, Польша. Точный адрес локации мы пришлём в Telegram после оплаты." },
        { q: "Можно ли вернуть билет?", a: "Возврат возможен до 7 дней до мероприятия согласно политике возврата." },
        { q: "Нужен ли дресс-код?", a: "Smart casual или business casual — комфортно и презентабельно." },
        { q: "Будут ли материалы?", a: "Да, фото и видео-репортаж раздаются всем участникам после мероприятия." },
      ],
    },
    footer: {
      brand: "Business Conference Wrocław",
      sub: "31.10 · 10:30 · Вроцлав, Польша",
      copy: "© {year} Business Conference Wrocław. Все права защищены.",
      contact_location: "Вроцлав, Польша",
      contact_date: "31.10 · 10:30",
      contact_tg: "@bizconf_warsaw",
    },
  },

  en: {
    nav: {
      brand: "Business Conf · Wrocław",
    },
    hero: {
      date_chip: "31.10",
      date_sub: "10:30 · Wrocław, Poland",
      title1: "BUSINESS",
      title2: "CONFERENCE",
      desc: "Upgrade your network, personal brand, and business among like-minded professionals in Wrocław. One day that changes the trajectory of your next year.",
      cta_tickets: "Choose ticket",
      cta_program: "View program",
      stat1k: "", stat1v: "",
      stat2k: "9", stat2v: "Formats",
      stat3k: "1", stat3v: "Day you'll remember",
      stage_kicker: "Main stage",
      stage_title: "Insight flow",
    },
    program: {
      eyebrow: "Inside",
      title: "Conference Program",
      desc: "Nine program elements, built so every guest leaves with real contacts and insights.",
      items: [
        { title: "Keynotes by top speakers", text: "Deep talks by practitioners with real experience and case studies." },
        { title: "Gifts for every guest", text: "Welcome kit and surprises from event partners." },
        { title: "Signature networking", text: "Structured format for meeting people — no awkward pauses." },
        { title: "Exclusive community chat", text: "Access to a private chat for attendees after the conference." },
        { title: "Welcome drink & finger food", text: "A light reception in a relaxed atmosphere." },
        { title: "Interactive workshops", text: "Hands-on sessions — you leave with tools, not theory." },
        { title: "Premium photo zone", text: "Perfect shots for social media and your personal brand." },
        { title: "Professional photo/video", text: "Full coverage — content you can use for months." },
        { title: "Afterparty", text: "Informal networking and a Mafia game with attendees." },
      ],
    },
    speakers: {
      eyebrow: "Stage",
      title: "Conference Speakers",
      desc: "Practitioners in business, marketing, investment and personal branding.",
      role_label: "Topic",
      list: [
        {
          name: "Marina Fedak",
          role: "Beauty entrepreneur 🇵🇱. In the beauty industry since 2017. Salon owner with a team of 15 people.",
          teaser: "Entrepreneurial Time Management: How to Balance Running a Business, Leading a Team, and Personal Life",
        },
        {
          name: "Roxolana IvRoxe",
          role: "Founder of the IvRoxe network of medical facilities. 7 locations across 6 cities in Poland, 70+ team members.",
          teaser: "Mistakes in business promotion and advertising that is effective in the Polish market",
        },
        {
          name: "Anastasiia Kasian",
          role: "Owner of @itpolski, a business Polish language school, and a marketing specialist with 10 years of experience in Poland (PORTA, MILKA, Disney, MasterCard).",
          teaser: "Where to Find Business Funding in Poland: Available Amounts, Required Documents, and Potential Pitfalls",
        },
        {
          name: "Anna Khoroshilova",
          role: "Content producer with 10 years of experience and a blogger with an audience of 7K+ followers.",
          teaser: "Is This Your Last Chance to Get on YouTube? Why You Should Launch Your Own Channel Today",
        },
        {
          name: "Viktor Bartak",
          role: "Owner of the No. 1 B2B SEO Agency, according to the UK Search Awards.",
          teaser: "Attracting Clients from Google and ChatGPT",
        },
        {
          name: "Tatiana Alekseeva",
          role: "Founder & Owner of RACCOON SCHOOL, an international network of education businesses in Ukraine and Poland with an 11-year history.",
          teaser: "The Psychology of a Business Owner: Positioning, Boundaries with the Team, Delegation, and Earning in a Crisis",
        },
      ],
      tba_title: "Speakers will be announced soon",
      tba_desc: "We are curating a strong lineup of practitioners from business, marketing, and investment. Stay tuned!",
    },
    atmosphere: { eyebrow: "Atmosphere", title: "Our atmosphere", desc: "" },
    organizers: {
      eyebrow: "Team",
      title: "Organizers",
      list: [
        {
          name: "Dina Zavadskaya",
          role: "Marketer with 4+ years experience, owner of 2 online businesses",
          photo: "/events/wroclaw-2026/speakers/Dina.jpeg",
        },
        {
          name: "Denis Novikov",
          role: "Business development & sales consultant with 15+ years experience, event producer, insurance agent",
          photo: "/events/wroclaw-2026/speakers/Denis.jpeg",
        },
      ],
    },
    pricing: {
      eyebrow: "Tickets",
      title: "Choose your participation format",
      desc: "Five options — from a standard ticket to a keynote stage speech.",
      footer: "Card payment via Stripe’s secure connection. After payment you’ll get access to the private attendees chat.",
      badges: { popular: "Popular", premium: "Premium" },
      tickets: {
        standard: {
          name: "Standard",
          sub: "",
          cta: "Get ticket",
          perks: [
            "Full access to the conference and all sessions",
            "Exclusive attendee community chat",
            "Welcome gifts & certificate of attendance",
          ],
        },
        standard_duo: {
          name: "Standard 1+1",
          sub: "For 2 attendees",
          cta: "Get for 2",
          perks: [
            "Everything in Standard — for two people",
            "Two tickets at a special bundle price (75 PLN / pers.)",
            "Shared networking & community chat access",
          ],
        },
        speaker_10: {
          name: "Speaker 10 min",
          sub: "Stage pitch",
          cta: "Speak 10 min",
          perks: [
            "Everything in Standard package",
            "10 minutes on stage to pitch yourself or your project",
            "Permission to distribute business cards or flyers",
          ],
        },
        speaker_30: {
          name: "Speaker 30 min",
          sub: "Keynote speaker",
          cta: "Speak 30 min",
          perks: [
            "Everything in Standard package",
            "30-minute keynote presentation from the main stage",
            "High-profile expert positioning & promotion across event channels",
          ],
        },
        afterparty: {
          name: "After party",
          sub: "Evening party",
          cta: "Join After party",
          perks: [
            "Informal networking in a club atmosphere",
            "Signature 'Mafia' game session with attendees & hosts",
            "Great entertainment & relaxed business connections",
          ],
        },
      },
    },
    partners: { eyebrow: "Partners", title: "Event sponsors" },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked",
      items: [
        { q: "Where is the conference held?", a: "Wrocław, Poland. We send the exact venue address via Telegram after payment." },
        { q: "Can I get a refund?", a: "Refunds are possible up to 7 days before the event according to the refund policy." },
        { q: "Is there a dress code?", a: "Smart casual or business casual — comfortable and presentable." },
        { q: "Will materials be available?", a: "Yes, photo and video coverage is shared with all attendees after the event." },
      ],
    },
    footer: {
      brand: "Business Conference Wrocław",
      sub: "31.10 · 10:30 · Wrocław, Poland",
      copy: "© {year} Business Conference Wrocław. All rights reserved.",
      contact_location: "Wrocław, Poland",
      contact_date: "31.10 · 10:30",
      contact_tg: "@bizconf_warsaw",
    },
  },

  pl: {
    nav: {
      brand: "Business Conf · Wrocław",
    },
    hero: {
      date_chip: "31.10",
      date_sub: "10:30 · Wrocław, Polska",
      title1: "BUSINESS",
      title2: "CONFERENCE",
      desc: "Rozwiń swój networking, markę osobistą i biznes w gronie profesjonalistów we Wrocławiu. Jeden dzień, który zmieni trajektorię Twojego kolejnego roku.",
      cta_tickets: "Wybierz bilet",
      cta_program: "Program dnia",
      stat1k: "", stat1v: "",
      stat2k: "9", stat2v: "Formatów",
      stat3k: "1", stat3v: "Dzień, który zapamiętasz",
      stage_kicker: "Główna scena",
      stage_title: "Strumień inspiracji",
    },
    program: {
      eyebrow: "W programie",
      title: "Program konferencji",
      desc: "Dziewięć elementów programu — tak ułożonych, by każdy uczestnik wyszedł z realnymi kontaktami i inspiracjami.",
      items: [
        { title: "Wystąpienia topowych prelegentów", text: "Głębokie prelekcje praktyków z doświadczeniem i konkretami." },
        { title: "Prezenty dla każdego gościa", text: "Welcome-pakiet i niespodzianki od partnerów wydarzenia." },
        { title: "Autorski networking", text: "Ustrukturyzowany format poznawania ludzi — bez niezręcznych przerw." },
        { title: "Zamknięta społeczność na czacie", text: "Dostęp do prywatnego czatu uczestników po konferencji." },
        { title: "Welcome drink i finger food", text: "Lekki bufet w przyjemnej atmosferze." },
        { title: "Interaktywne warsztaty", text: "Praktyczne sesje — wynosisz narzędzia, nie teorię." },
        { title: "Premium strefa foto", text: "Idealne kadry do social mediów i marki osobistej." },
        { title: "Profesjonalne foto i wideo", text: "Pełna realizacja — materiały na Twój content." },
        { title: "Afterparty", text: "Nieformalny networking i partyjka „Mafii” z uczestnikami." },
      ],
    },
    speakers: {
      eyebrow: "Scena",
      title: "Prelegenci konferencji",
      desc: "Praktycy z biznesu, marketingu, inwestycji i marki osobistej.",
      role_label: "Temat",
      list: [
        {
          name: "Marina Fedak",
          role: "Przedsiębiorczyni z branży beauty 🇵🇱. W branży beauty od 2017 roku. Właścicielka salonu z 15-osobowym zespołem.",
          teaser: "Zarządzanie czasem przedsiębiorcy: jak łączyć prowadzenie biznesu, zarządzanie zespołem i życie prywatne",
        },
        {
          name: "Roxolana IvRoxe",
          role: "Założycielka sieci placówek medycznych IvRoxe. 7 lokalizacji w 6 miastach Polski, ponad 70 osób w zespole.",
          teaser: "Błędy w promocji biznesu i reklama, która jest skuteczna na polskim rynku",
        },
        {
          name: "Anastasiia Kasian",
          role: "Właścicielka szkoły biznesowego języka polskiego @itpolski i marketerka z 10-letnim doświadczeniem w Polsce (PORTA, MILKA, Disney, MasterCard).",
          teaser: "Gdzie szukać dofinansowania dla biznesu w Polsce: dostępne kwoty, wymagane dokumenty i pułapki",
        },
        {
          name: "Anna Khoroshilova",
          role: "Producentka treści z 10-letnim doświadczeniem i blogerka z 7K+ obserwujących.",
          teaser: "Ostatnia szansa, by wejść na YouTube? Dlaczego warto założyć własny kanał już dziś",
        },
        {
          name: "Viktor Bartak",
          role: "Właściciel agencji SEO nr 1 w B2B według UK Search Awards.",
          teaser: "Pozyskiwanie klientów z Google i ChatGPT",
        },
        {
          name: "Tatiana Alekseeva",
          role: "Founder & Owner międzynarodowej sieci RACCOON SCHOOL, biznesu edukacyjnego w Ukrainie i Polsce z 11-letnią historią.",
          teaser: "Psychologia właściciela biznesu: pozycjonowanie, granice z zespołem, delegowanie i zarabianie w kryzysie",
        },
      ],
      tba_title: "Prelegenci zostaną ogłoszeni wkrótce",
      tba_desc: "Tworzymy mocny skład praktyków biznesu, marketingu i inwestycji. Śledź aktualizacje!",
    },
    atmosphere: { eyebrow: "Atmosfera", title: "Nasza atmosfera", desc: "" },
    organizers: {
      eyebrow: "Zespół",
      title: "Organizatorzy",
      list: [
        {
          name: "Dina Zavadskaya",
          role: "Marketerka z 4+ letnim doświadczeniem, właścicielka 2 biznesów online",
          photo: "/events/wroclaw-2026/speakers/Dina.jpeg",
        },
        {
          name: "Denis Novikov",
          role: "Konsultant ds. rozwoju biznesu i sprzedaży z ponad 15-letnim doświadczeniem, producent wydarzeń, agent ubezpieczeniowy",
          photo: "/events/wroclaw-2026/speakers/Denis.jpeg",
        },
      ],
    },
    pricing: {
      eyebrow: "Bilety",
      title: "Wybierz format uczestnictwa",
      desc: "Pięć opcji — od standardowego biletu po wystąpienie na scenie głównej.",
      footer: "Płatność kartą przez bezpieczne połączenie Stripe. Po opłaceniu otrzymasz dostęp do zamkniętego czatu uczestników.",
      badges: { popular: "Popularny", premium: "Premium" },
      tickets: {
        standard: {
          name: "Standard",
          sub: "",
          cta: "Kup bilet",
          perks: [
            "Pełny dostęp do konferencji i wszystkich prelekcji",
            "Zamknięta społeczność na czacie uczestników",
            "Upominki powitalne i certyfikat uczestnictwa",
          ],
        },
        standard_duo: {
          name: "Standard 1+1",
          sub: "Dla 2 osób",
          cta: "Kup dla 2 osób",
          perks: [
            "Wszystko co w pakiecie Standard — dla dwóch osób",
            "Dwa bilety w promocyjnej cenie (75 PLN / os.)",
            "Wspólny networking i dostęp do zamkniętego czatu",
          ],
        },
        speaker_10: {
          name: "Speaker 10 min",
          sub: "Wystąpienie ze sceny",
          cta: "Wystąp 10 min",
          perks: [
            "Wszystko co w pakiecie Standard",
            "10 minut o sobie lub projekcie przed całą publicznością",
            "Możliwość rozdania wizytówek lub ulotek uczestnikom",
          ],
        },
        speaker_30: {
          name: "Speaker 30 min",
          sub: "Główny prelegent",
          cta: "Wystąp 30 min",
          perks: [
            "Wszystko co w pakiecie Standard",
            "30 minut wystąpienia z prezentacją ze sceny głównej",
            "Mocne pozycjonowanie eksperckie i promocja w kanałach wydarzenia",
          ],
        },
        afterparty: {
          name: "After party",
          sub: "Impreza wieczorna",
          cta: "Kup After party",
          perks: [
            "Nieformalny networking w klubowej atmosferze",
            "Kultowa gra w „Mafię” z uczestnikami i organizatorami",
            "Świetna zabawa i nawiązywanie relacji biznesowych",
          ],
        },
      },
    },
    partners: { eyebrow: "Partnerzy", title: "Wspierają wydarzenie" },
    faq: {
      eyebrow: "FAQ",
      title: "Najczęstsze pytania",
      items: [
        { q: "Gdzie odbywa się konferencja?", a: "Wrocław, Polska. Dokładny adres lokalizacji przyślemy w Telegramie po opłaceniu." },
        { q: "Czy mogę zwrócić bilet?", a: "Zwrot jest możliwy do 7 dni przed wydarzeniem zgodnie z polityką zwrotów." },
        { q: "Czy obowiązuje dress code?", a: "Smart casual lub business casual — wygodnie i reprezentacyjnie." },
        { q: "Czy będą materiały?", a: "Tak, foto i wideo-relacja trafia do wszystkich uczestników po wydarzeniu." },
      ],
    },
    footer: {
      brand: "Business Conference Wrocław",
      sub: "31.10 · 10:30 · Wrocław, Polska",
      copy: "© {year} Business Conference Wrocław. Wszelkie prawa zastrzeżone.",
      contact_location: "Wrocław, Polska",
      contact_date: "31.10 · 10:30",
      contact_tg: "@bizconf_warsaw",
    },
  },
};

export default EVENT_TRANSLATIONS;
